//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'christmas_form_five',
        data(){
            return{
                
            }
        },
        methods:{
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            }
        },
        created(){
           
        }
    }



// WEBPACK FOOTER //
// ./src/components/christmas_form_five.vue